import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StaffEmployee, StaffEmployeeSearchParams} from '@accounting/_common/models/staff-employee.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[StaffEmployees] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffEmployee[] } }>()
);

export const CheckStateSuccess = createAction(
    '[StaffEmployees] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffEmployee[] } }>()
);

export const LoadCategories = createAction(
    '[StaffEmployees] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[StaffEmployees] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[StaffEmployees] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[StaffEmployees] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[StaffEmployees] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[StaffEmployees] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[StaffEmployees] Load List Success',
    props<{ payload: { items: StaffEmployee[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[StaffEmployees] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[StaffEmployees] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[StaffEmployees] Set Filter',
    props<{ payload: StaffEmployeeSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[StaffEmployees] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[StaffEmployees] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[StaffEmployees] Update Item Success',
    props<{ payload: StaffEmployee }>()
);

export const DeleteItem = createAction(
    '[StaffEmployees] Delete Item',
    props<{ payload: StaffEmployee }>()
);

export const DeleteItemSuccess = createAction(
    '[StaffEmployees] Delete Item Success',
    props<{ payload: StaffEmployee }>()
);

export const DeleteItemFailure = createAction(
    '[StaffEmployees] Delete Item Failure',
    props<{ payload: StaffEmployee }>()
);

export const SetInitialState = createAction(
    '[StaffEmployees] Set Initial State'
);

export const UpdateStaffEmployeeItem = createAction(
    '[StaffEmployees] Update StaffEmployee Item',
    props<{ payload: StaffEmployee }>()
);
